import { render, staticRenderFns } from "./OseLogoIcon.vue?vue&type=template&id=0f539c72&"
import script from "./OseLogoIcon.vue?vue&type=script&lang=js&"
export * from "./OseLogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports